function StatCard({ title, value, subtitle, color = 'var(--primary)', onClick, clickable }) {
  const isClickable = clickable || onClick;

  return (
    <div onClick={onClick} style={{
      background: 'var(--bg-card)', border: '1px solid var(--border)',
      borderRadius: 'var(--radius)', padding: '14px 16px', textAlign: 'center',
      boxShadow: 'var(--shadow)', cursor: isClickable ? 'pointer' : 'default',
      transition: 'var(--transition)', flex: '1 1 160px', minWidth: '140px',
      position: 'relative', overflow: 'hidden'
    }} onMouseEnter={e => {
      if (isClickable) {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = 'var(--shadow-md)';
      }
    }} onMouseLeave={e => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = 'var(--shadow)';
    }}>
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: '3px',
        background: color, borderRadius: 'var(--radius) var(--radius) 0 0'
      }} />
      <div style={{
        fontSize: '11px', fontWeight: '600', textTransform: 'uppercase',
        letterSpacing: '0.5px', color: 'var(--text-secondary)',
        marginBottom: '8px', marginTop: '2px'
      }}>{title}</div>
      <div style={{
        fontSize: '28px', fontWeight: '700', color: color,
        lineHeight: 1.2, fontVariantNumeric: 'tabular-nums'
      }}>
        {value !== undefined && value !== null ? value.toLocaleString() : '—'}
      </div>
      {subtitle && (
        <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '6px', fontWeight: '500' }}>
          {subtitle}
        </div>
      )}
      {isClickable && (
        <div style={{ fontSize: '10px', color: 'var(--primary)', marginTop: '6px', fontWeight: '500', opacity: 0.8 }}>
          Click for details →
        </div>
      )}
    </div>
  );
}

export default StatCard;

